const cookieConsent = {
  // ablyft: ["statistics"],
  prepr: ["marketing"],
};

export default cookieConsent;
